const SELLERS_IMAGE_PATH = "sellers/originals/";

export { SELLERS_IMAGE_PATH };
